export const LOADING_SESSION_NOTIFICATION = "LOADING_SESSION_NOTIFICATION";
export const SAVE_LOADING_SESSION_NOTIFICATION =
  "SAVE_LOADING_SESSION_NOTIFICATION";
export const GET_SESSION_NOTIFICATION = "GET_SESSION_NOTIFICATION";
export const FORM_FAIL = "FORM_FAIL";
export const SESSION_NOTIFICATION_FAIL = "SESSION_NOTIFICATION_FAIL";
